module.exports = __webpack_public_path__ + "static/img/about_zhuzq04.9820be8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about_zhuzq04.png
// module id = pWBJ
// module chunks = 1